import React, { useEffect, useState } from "react";
import CustomSelect from "../common/Select";
import axios from "../../axios/axiosconf";



function SelectorPais({ value, onChange, readOnly = false, placeholder = "Seleccione...", cuestionarioPacienteId, cuestionarioToken }) {
  const [paises, setPaises] = useState([]);
  const [cargando, setCargando] = useState(true);

  const esCuestionarioPublico = Boolean(cuestionarioPacienteId && cuestionarioToken);

  useEffect(() => {
    const params = esCuestionarioPublico
      ? { paciente_id: cuestionarioPacienteId, token: cuestionarioToken }
      : {};
    const url = esCuestionarioPublico ? "/pais-cuestionario" : "/pais";

    axios.get(url, { params })
      .then((res) => {
        const opciones = res.data.map((p) => ({
          value: p.id,
          label: p.nombre_pais
        }));
        setPaises(opciones);
      })
      .catch((err) => console.error(err))
      .finally(() => setCargando(false));
  }, [esCuestionarioPublico, cuestionarioPacienteId, cuestionarioToken]);

  // Manejar tanto valores numéricos como de objeto
  const obtenerValorSeleccionado = () => {
    if (!value) return null;

    // Si value es un número (ID), buscar en la lista
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      return paises.find(p => p.value == value) || null;
    }

    // Si value es un objeto con propiedad value (ya formateado)
    if (value && typeof value === 'object' && value.value) {
      return value;
    }

    return null;
  };

  const valorSeleccionado = obtenerValorSeleccionado();

  return (
    <CustomSelect
      isLoading={cargando}
      options={paises}
      value={valorSeleccionado}
      onChange={onChange}
      placeholder={placeholder}
      isClearable
      isDisabled={readOnly || cargando}
    />
  );
}

export default SelectorPais;